// 不需要加载loading 的情况
export const NoLoading = [
]

// 开发环境
export const ISDEVELOPMENT = process.env.ANNE_APP_MODE === 'dev'
// 测试环境
export const ISTEST = process.env.ANNE_APP_MODE === 'testing'
// 线上环境
export const ISPRODUCTION = process.env.ANNE_APP_MODE === 'pro'

// 企业微信包名 GATEWAY-USER-AGENT
export const GATEWAY_USER_AGENT = ';;;;com.renrenche.wecom';
// 定价小程序包名 FIXPRICE_USER_AGENT
export const FIXPRICE_USER_AGENT = ';;;;rrc.mini.pricing';

export const GATEWAYPREFIX = { // 网关前缀，便于统一调整
  business_appgate_insWorkOrderService: '/parking_server-mas_model_business/', // 服务:ins-work-order-service 业务人员用appgate域名，后面逐渐代替掉 saas和reinstall
  saas: '/parking_server-mas_model_business/', // 服务:ins-work-order-service   业务人员用appgate域名
  reinstall: '/parking_server-mas_model_business', // 服务:ins-work-order-service
  reinstallPartner: '/parking_server-mas_model_partner', // 服务:ins-work-order-service   合伙人账户体系用appgate域名 合伙人app
  saleDealOrder: '/sale_deal_order', // 销售的服务 sale-deal-order
  carSample: '/car_sample', // 严选车抽检-H5页，帮我拍，不走验证
  reLaunch: '/republish_vehicle', // 不走网关登录校验
  realVehicle: '/vehicle_real_app', // 真车源
  cstReinstall: '//cheshangtongapi.58.com'
}


// 与网关约定好的key, secret, 公网访问时使用
export const PRIVATE_KEY_SECRET = {
  // 网关path：republish_vehicle
  shareH5Jwt: {
    test: {
      key: 'fuedmn4rxzg96xzkhqx6bdys4znrykjz',
      secret: 'mq4cpyxfr28d5bbspp4qu6rc85zey27q'
    },
    production: {
      key: 'y3npqgg3xuakacdpk5mgqmjqsfdzv2gr',
      secret: 'mrfqzyek6pvxccs3dmusjr8v6weft2tz'
    }
  },
  // 网关path： /app/inspector_userback
  inspectorUserback: {
    test: {
      key: 's7jpy3mvrfqsxjbpah6kwk2u25gvg3e6',
      secret: 'urej8sep46skgs26rtcu3q3jwf4s6r43'
    },
    production: {
      key: 'r2emn87ckxusbjtume7vkp5mjt4zrkyw',
      secret: '6pfecfp3bn3ukcek37k6y9hfeheyevjm'
    }
  },
}
